import axios from 'axios';
const DAO_KATALOG_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/katalog';
export async function getKatalogi(id_katalog_parent) {
    let res = await axios(DAO_KATALOG_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: { operacja: "getKatalogi", id_pkat:id_katalog_parent  }
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => {
        console.log("ass:" + err.message);
        throw err;
    });
    console.log("getKatalogi: res:" + JSON.stringify(res));
    return res;
}

export async function usunKatalog(id_katalog) {
    let res = await axios(DAO_KATALOG_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: { operacja: "usunKatalog", id_kat:id_katalog  }
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => {
        console.log("ass:" + err.message);
        throw err;
    });
    console.log("getKatalogi: res:" + JSON.stringify(res));
    return res;
}


export async function dodajKatalog(id_pkat,id_kat,nazwa) {
    let res = await axios(DAO_KATALOG_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: { operacja: "dodajKatalog", id_pkat:id_pkat, id_kat:id_kat,nazwa:nazwa  }
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => {
        console.log("ass:" + err.message);
        throw err;
    });
    console.log("dodajKatalog: res:" + JSON.stringify(res));
    return res;
}